module.exports = __webpack_public_path__ + "img/S10.80594a2f.svg";